/**
 * @return {object} onClick event
 */
export function clickEvent(vue, label) {
  vue.$emit("onClick", { label: label });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/helpers/events.js
// module id = 546
// module chunks = 1